import React, { useState } from 'react';
import KPISet from '../components/KPISet';
import List from './List';
import JSONPretty from 'react-json-pretty';

const dataProviderName = 'administrations/revenueinvoicerow';

const Default = () => {
    const [tabValue, setTabValue] = useState(0);
    const defaultFilters = { items: [] };

    return <>
        <KPISet dataProviderName={dataProviderName} filters={defaultFilters} />
        <List filters={defaultFilters} />
    </>

}

export default Default;


